export default {
  data() {
    return { staticAssetsPath: 'https://dfkjvbenn7r2b.cloudfront.net' };
  }
};
